module.exports = __webpack_public_path__ + "static/media/Sketch6.279b87ed.jpeg";